// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "twilio-voice" + "." + "351b3cf2" + ".chunk.js";
};